import { apiAuth } from "../../http";

export const getLogout = async (): Promise<any> => {
  const response = apiAuth()
    .get("/logout")
    .then(({ data }) => data);
  return response;
};
